/*
 * CUSTOMIZATIONS:
 * - use prop from controlpanel if definied, else use Header logo as default
 */
import { Logo } from 'design-comuni-plone-theme/components/ItaliaTheme';

import { SiteProperty } from 'volto-site-settings';
import config from '@plone/volto/registry';

const LogoFooter = () => {
  const site_logo_footer = SiteProperty({
    property: 'site_logo_footer',
    className: 'icon',
    alt: 'Logo',
    getValue: true,
  });

  const logo_height = config.settings?.['volto-site-settings']?.logo_height;
  const logo_scale = logo_height / (site_logo_footer?.height ?? 1);

  return site_logo_footer ? (
    <img
      src={site_logo_footer.url}
      height={logo_height}
      width={site_logo_footer.width * logo_scale}
      className="icon"
      alt="Logo"
    />
  ) : (
    <Logo />
  );
};

export default LogoFooter;
